import * as React from "react";
import {
    Flex,
    Box,
} from "@chakra-ui/react";
import {RootState} from "@src/store";
import {useAppSelector} from "@store/hooks";
import i18n from "i18next";
import {useTranslation} from "react-i18next";
import useTitle from "@hooks/useTitle";
import LoginForm from "@pages/auth/_LoginForm";
import Footer from "@components/footer";

const Login = () => {
    const {t} = useTranslation();
    const lang = i18n.language;
    const {websiteSettings} = useAppSelector((state: RootState) => state.websiteSettings);

    useTitle(t(("documentTitle.auth")))

    return (
        <Box
            position={"relative"}
            minH={"100vh"}
            overflow={"hidden"}
            bg={"custom.brand_primaryDark"}
        >
            <Box
                pos={"absolute"}
                top={"-30vw"}
                left={"-20vw"}
                w={"50vw"}
                h={"50vw"}
                transform={"rotate(45deg)"}
                bg={"custom.brand_loginBlock"}
                borderRadius={"10vw"}
            />
            <Box
                pos={"absolute"}
                bottom={"-30vw"}
                right={"-20vw"}
                w={"50vw"}
                h={"50vw"}
                transform={"rotate(45deg)"}
                bg={"custom.brand_loginBlock"}
                borderRadius={"10vw"}
            />
            <Flex
                pos={"relative"}
                zIndex={"1"}
                minH={"100vh"}
                flexDir={"column"}
            >
                <Flex
                    flex={"1"}
                    align={"center"}
                    justifyContent={"center"}
                    py={{base: "40px", md: "0"}}
                >
                    <Flex
                        flexDir={"column"}
                        w={"480px"}
                        maxW={"full"}
                        mx={{base: "16px", md: "0"}}
                        p={{base: "80px 32px 32px", md: "80px 60px 60px"}}
                        bg={"custom.gray_50"}
                    >
                        <LoginForm websiteSettings={websiteSettings} lang={lang} />
                    </Flex>
                </Flex>
                <Box px={"24px"} py={"16px"}>
                    <Footer />
                </Box>
            </Flex>
        </Box>
    );
};

export default Login;
